import * as Yup from 'yup';

import { Attachment } from '@eika/file-uploader';

import { toUploadedVedleggDTO, UploadedVedlegg } from '../../sporsmalsflyt/filopplasting/filopplasting-types';
import { EttersendingDTO } from '../../types/generated-types';
import { InternalAttachment } from './attachment-types';

export type EttersendingData = {
    skadenummerEllerForsikringsnummer: string;
    infoText: string;
    epost?: string;
};

export const ettersendingSporsmal = {
    skadenummerEllerForsikringsnummer: 'Hva er skadenummeret ditt?',
    infoText: 'Er det noe mer du vil tilføye?',
    epost: 'Din e-post',
};

export const validSkadenummerOrForsikringsnummerRegex: RegExp = RegExp('^\\d+[,.]?\\d{0,9}$');
export const validEpostRegex: RegExp = RegExp('[^@]+@[^@]+\\.[a-zA-Z]+');

const errorTexts = {
    genericPropertyMissing: 'Du må svare på dette før du kan gå videre',
    emailMissing: 'Du må oppgi e-postadresse før du kan gå videre',
    emailInvalid: 'E-postadressen er ikke gyldig',
    skadenummerEllerForsikringsnummerMissing: 'Vi trenger et skadenummer eller forsikringsnummer',
    skadenummerEllerForsikringsnummerInvalid: 'Dette er ikke et gyldig forsikringsnummer eller skadenummer',
};

export const validationSchemaEttersending = () =>
    Yup.object().shape({
        skadenummerEllerForsikringsnummer: Yup.string()
            .matches(validSkadenummerOrForsikringsnummerRegex, {
                message: errorTexts.skadenummerEllerForsikringsnummerInvalid,
            })
            .required(errorTexts.skadenummerEllerForsikringsnummerMissing),
        infoText: Yup.string().required(errorTexts.genericPropertyMissing),
        epost: Yup.string().matches(validEpostRegex, errorTexts.emailInvalid).required(errorTexts.emailMissing),
    });

export const generateEttersendingDTO = (
    ettersendingData: EttersendingData,
    attachments: InternalAttachment[],
): EttersendingDTO => {
    const vedlegg: UploadedVedlegg = {
        vedleggIds: attachments
            .filter((i) => i.internalId !== null)
            .map((i) => {
                return {
                    id: i.internalId,
                    fileName: i.fileName,
                };
            }),
    };

    return {
        informasjon: { sporsmal: ettersendingSporsmal.infoText, svar: ettersendingData.infoText },
        kundeEpost: { sporsmal: ettersendingSporsmal.epost, svar: ettersendingData.epost },
        skadeEllerForsikringsnummer: {
            sporsmal: ettersendingSporsmal.skadenummerEllerForsikringsnummer,
            svar: ettersendingData.skadenummerEllerForsikringsnummer,
        },
        vedlegg: toUploadedVedleggDTO(vedlegg),
    };
};

export const partitionAttachments = (
    list: Attachment[],
    fn: (val: Attachment, i: number, list: Attachment[]) => NonNullable<unknown>,
): Attachment[][] =>
    list.reduce(
        (acc, val, i, list) => {
            acc[fn(val, i, list) ? 0 : 1].push(val);
            return acc;
        },
        [[], []],
    );
